<template>
  <el-card v-loading="loading" shadow="hover">
    <div style="padding: 10px 20px">
      <div v-if="editModel">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="旧的密码" prop="password">
            <el-input
              type="password"
              v-model="editModel.password"
              auto-complete="off"
              placeholder="请输入旧的密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="新的密码" prop="newPassword">
            <el-input
              type="password"
              v-model="editModel.newPassword"
              auto-complete="off"
              placeholder="请输入新的密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmNewPassword">
            <el-input
              type="password"
              v-model="editModel.confirmNewPassword"
              auto-complete="off"
              placeholder="请输入确认密码"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              @submit.native.prevent
              @click="submitClick"
            >
              确认
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params,
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query,
      );
    },
  },
  data() {
    return {
      loading: false,
      editSubmit: false,
      editModel: {
        password: '',
        newPassword: '',
        confirmNewPassword: '',
      },
      editRules: {
        password: [
          {
            required: true,
            message: '请输入旧的密码',
            trigger: 'change',
          },
        ],
        newPassword: [
          {
            required: true,
            message: '请输入新的密码',
            trigger: 'change',
          },
        ],
        confirmNewPassword: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'));
              } else if (value !== this.editModel.newPassword) {
                callback(new Error('两次输入密码不一致!'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
      },
    };
  },
  methods: {
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          this.requestApi('biz.customer.account.auth.editPassword', this.editModel, {
            showError: true
          }).then((resp) => {
            this.success('密码重置成功');
            this.$drawer.refreshDrawer();
            this.$drawer.backDrawer();
          }).finally(() => {
            this.editSubmit = false;
          });
        } else {
          this.showValidate(data);
        }
      });
    },
  },
};
</script>
